import { Helmet } from "react-helmet-async";

const SITE = "MacroMatrix";
const BASE_URL = "https://macromatrix.io";

export default function SEO({ title, description, path = "" }) {
  const full = title ? `${title} | ${SITE}` : SITE;
  const url = `${BASE_URL}${path}`;
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
